import React from 'react';
import VehicleForm from '../components/VehicleForm';
import VehicleList from '../components/VehicleList';
import useVehicles from '../hooks/useVehicles';

const VehiclesPage = ({ user }) => {
  const { vehicles, addVehicle, editVehicle, removeVehicle, editingVehicle, setEditingVehicle, genericSavedMsg } = useVehicles();
  const isConductor = user?.role === "Conductor" || user?.role === "conductor";

  return (
    <div className="space-y-6">
      {genericSavedMsg && (
        <div className="bg-green-100 text-green-800 px-4 py-2 rounded">
          {genericSavedMsg}
        </div>
      )}
      {!isConductor && (
        <VehicleForm
          onSave={editingVehicle ? editVehicle : addVehicle}
          editingVehicle={editingVehicle}
          onCancelEdit={() => setEditingVehicle(null)}
        />
      )}
      <VehicleList
        vehicles={vehicles}
        onRemove={isConductor ? undefined : removeVehicle}
        onEdit={isConductor ? undefined : setEditingVehicle}
        isConductor={isConductor}
      />
    </div>
  );
};

export default VehiclesPage;